import 'sass/app.scss';

import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { PasswordInfo, FieldFactory } from 'client/shared/components';
import LoginForm from './login-form';
import ResetPasswordForm from './login-form/reset-password-form';

const addProps = (Comp, props) => {
	return class extends Component {
		render () {
			return <Comp { ...props } { ...this.props } />;
		}
	}
};

@inject('formStore', 'userStore', 'apiStore')
@observer
class RestPasswordButton extends Component {
	render () {
		const { formStore: { validation } } = this.props;
		const isValid = validation['user.password'] && validation['user.confirmPassword'];

		return (
			<button
				onClick={ this.onClick }
				disabled={ isValid !== true }
				className="button hollow expanded"
			>
				Reset Password
			</button>
		);
	}

	@autobind
	onClick () {
		const { userStore, apiStore } = this.props;
		apiStore.updatePassword(userStore.data.user.toPOJO());
	}
}

@inject('formStore', 'userStore')
@observer
class RestPasswordForm extends Component {
	render() {
		const { formStore, userStore } = this.props;

		if (userStore.isLoading) {
			return <h1>Logging in...</h1>;
		}

		const Field = addProps(FieldFactory, {
			store: userStore,
			formStore: formStore
		});

		return (
			<div className="grid-x">
				<div className="cell">
					<h4>Reset your password.</h4>
				</div>

				<div className="cell">
					<Field
						label="New Password"
						fieldKey="user.password"
						changeOnBlur={ false }
						noFieldClass
					/>

					<Field
						noFieldClass
						changeOnBlur={ false }
						fieldKey="user.confirmPassword"
						validate={ this.validateConfirmPassword }
					/>

					<PasswordInfo columns="1" />

					<div className="padding-top-1">
						<RestPasswordButton />
					</div>
				</div>
			</div>
		);
	}

	@autobind
	validateConfirmPassword (confirmPassword, key) {
		const { formStore, userStore } = this.props;
		const value = {
			confirmPassword,
			password: userStore.get('user.password')
		};

		return formStore.validate(value, key);
	}
}

@inject('formStore', 'userStore')
@observer
class LoginRoot extends Component {
	componentDidMount () {
		this.props.userStore.isLoading = false;
	}

	render() {
		const forcePasswordReset = false;

		return (
			<div>
				<div className="grid-x" style={{height:'100vh'}}>
					<div className="cell small-12 center-login">
						<div className="callout lite-container">
							{
								forcePasswordReset ?
									this.renderResetPassword() : this.renderLogin()
							}
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderLogin () {
		const { userStore } = this.props;
		const loginError = userStore.loginError ? <p data-ta="login-error" style={{color:'#a94442'}}>Login Failed. Please check your username & password, and try again.</p> : null;
		return (
			<div>
				<LoginForm
					clickHandler={ this.handleClick }
					keyHandler={ this.onKeyPress }
					{ ...this.props }
					loginError={loginError}
				/>
			</div>
		);
	}

	renderResetPassword () {
		return (
			<ResetPasswordForm { ...this.props } />
		);
	}

	@autobind
	onKeyPress ({ key, user }) {
		if ((/enter/i).test(key)) {
			this.handleClick(user);
		}
	}

	@autobind
	async handleClick (user) {
		this.props.userStore.loginError = false;
		this.props.userStore.checkLogin(user);
	}
}

// Wrap the component to inject dispatch and state into it
export default LoginRoot;
